/**
 * 获取当前页面的查询字符串
 * @returns [string, URLSearchParams]
 * URLSearchParams 对象
 * - 解析查询字符串：可以将 URL 的查询字符串（比如 "?key=value&foo=bar"）解析成键值对。
 * - 读取参数：通过 .get(key)、.getAll(key) 和 .has(key) 获取特定参数的值或检查参数是否存在。
 * - 修改参数：可以使用 .set(key, value) 替换参数，使用 .append(key, value) 添加新的参数，以及使用 .delete(key) 移除参数。
 * - 遍历参数：可以通过 .keys()、.values()、.entries() 或 .forEach() 迭代所有的键值对。
 * - 序列化：调用 .toString() 方法可以将其转换为 URL 查询字符串格式。
 * 为什么不用 window.location.search？
 * window.location.search 返回是挟带问号的查询字符串，而 URLSearchParams 对象是不带问号的查询字符串。
 */
export function getCurrentQueryString(): [string, URLSearchParams] {
  const search = new URLSearchParams(window.location.search);
  const str = search.toString();

  return [str, search];
}

export function searchParams2String() {
  const str = getCurrentQueryString()[0];
  return str;
}

/**
 * @description 根据当前url和查询字符串生成当前页面的完整路径。
 * @example 很多业务在 console 和 platform 都是相同的组件,只是路径不同. 跳转的时候避免不了需要拼接路径.
 * 但是路径通常包含当前的位置的动态参数 比如 cluster 和 tenant.
 * 可以使用这个函数来生成完整的路径.
 * @param additionalPath 附加的路径部分, 默认是空字符串.
 * @return 返回当前页面的完整路径字符串.
 * @example
 * composeUrl('/new-path') // 返回 '/current-path/new-path?query=string
 */
export function composeUrl(additionalPath = ''): string {
  const { pathname, search } = window.location;
  // 确保 pathname 和 additionalPath 之间只有一个斜杠
  const normalizedPathname = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  const normalizedAdditionalPath = additionalPath.startsWith('/')
    ? additionalPath.slice(1)
    : additionalPath;

  const fullPath = `${normalizedPathname}/${normalizedAdditionalPath}${search}`;

  return fullPath;
}

/** 获取查询字符串指定的属性值 */
export const getUrlSearchParamValue = (key: string) => {
  // 获取当前URL的查询字符串
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  // 获取查询字符串里面指定属性参数的值
  const value = urlParams.get(key);

  return value;
};
